// formHandlers.js
export const handleFormDataChange = (formData, setFormData, updatedData) => {
  if (updatedData && typeof updatedData === "object") {
    const updatedFormData = {
      ...formData,
      ...Object.entries(updatedData).reduce((acc, [key, value]) => {
        // Handle array updates by ensuring shallow copy for immutability
        acc[key] = Array.isArray(value)
          ? [...value] // Spread array to avoid direct mutation
          : value;
        return acc;
      }, {}),
    };

    setFormData(updatedFormData);
    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  } else {
    console.error("Invalid updatedData:", updatedData);
  }
};

  export const handleNextStep = (setStep) => {
    setStep((prevStep) => prevStep + 1);
  };
  
  export const handlePreviousStep = (setStep) => {
    setStep((prevStep) => prevStep - 1);
  };

    // Generic input handler
   export const handleInputChange = ({ target: { name, value } }) => {
    handleFormDataChange({ [name]: value });
    };
    